import axiosClient from "api/axiosInstance";

export const getPortfolios = async (): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/portfolios`);

  return response.data;
};

export const getPortfolio = async (portfolioId: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(`/portfolios/${portfolioId}`);

  return response.data;
};

export const createPortfolio = async (postData): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(`/portfolios`, postData);

  return response.data;
};

export const savePortfolio = async (
  portfolioId: number,
  postData: any,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.put(`/portfolios/${portfolioId}`, postData);

  return response.data;
};

export const deletePortfolio = async (portfolioId: number): Promise<any> => {
  const client = axiosClient();

  const response = await client.delete(`/portfolios/${portfolioId}`);

  return response.data;
};

export const getPortfolioPriceLimits = async (
  portfolioId: number,
  auctionTypeId: number,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.get(
    `/portfolios/${portfolioId}/price-limits?nordpoolAuctionTypeId=${auctionTypeId}`,
  );

  return response.data;
};

export const savePortfolioPriceLimits = async (
  portfolioId: number,
  postData: any,
): Promise<any> => {
  const client = axiosClient();

  const response = await client.post(
    `/portfolios/${portfolioId}/price-limits`,
    postData,
  );

  return response.data;
};
